import { dispatch } from 'nike-re-framejs';
import axios from 'axios';
import { getUrl } from '@/common/oldMobile';
import DmsService from '@/uploadDocument/services/DmsService';

export const saveChangePhoneNumberConfig = data => db => db.update(DmsService.processConfigDataUpdater(data));

export const getChangePhoneNumberDocConfig = db => {
    const path = ['documentsUpload', 'config'];

    if (!db.getIn(path)) {
        axios.get(getUrl('CHANGE_PHONE_NUMBER_INIT')).then(data => dispatch(saveChangePhoneNumberConfig(data)));
    }

    return db;
};

export const cleanupDocUploads = db => {
    return db.deleteIn(['documentsUpload']);
};
